/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Full_Teal_Falcon_TrotInputs */

const en_full_teal_falcon_trot = /** @type {(inputs: Full_Teal_Falcon_TrotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assigned peer feedback templates`)
};

const de_full_teal_falcon_trot = /** @type {(inputs: Full_Teal_Falcon_TrotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugewiesene Peer-Feedback Vorlagen`)
};

/**
* | output |
* | --- |
* | "Assigned peer feedback templates" |
*
* @param {Full_Teal_Falcon_TrotInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const full_teal_falcon_trot = /** @type {((inputs?: Full_Teal_Falcon_TrotInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Full_Teal_Falcon_TrotInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_full_teal_falcon_trot(inputs)
	return de_full_teal_falcon_trot(inputs)
});